<template>
    <div>
        <v-layout row wrap>
            <v-flex xs10 lg8 offset-xs1 offset-lg2>
                <v-card class="pa-2">
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs10>
                                <p class="subheading ma-0" style="font-weight:500">DB</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-text-field multi-line v-model="connString" disabled></v-text-field>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

export default {
    data() {
        return {
            connString: '',
        };
    },

    computed: {
        isRoot() {
            return this.$store.getters.profile.isRoot;
        },
    },
    created() {
        this.fetch();
    },

    methods: {
        async fetch() {
            await this.$store.dispatch('fetchConnString');
            this.connString = this.$store.getters.connString;
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/admin/Server.vue